import { render, staticRenderFns } from "./PscsNotificationErrorDialog.vue?vue&type=template&id=03c74fd5"
import script from "./PscsNotificationErrorDialog.vue?vue&type=script&lang=js"
export * from "./PscsNotificationErrorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports